var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	43591: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.0.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	24185: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.13.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	20287: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	82904: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	70291: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	79790: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=15.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	10473: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	67273: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	80582: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.0.0 || ^16.0.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	17986: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.0.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	4266: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	28975: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	23398: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	67465: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=15.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	32196: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	83100: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	71962: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	37794: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	30873: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	36119: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	43848: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	93788: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "16 - 18",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	98458: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17 || ^18 || ^19",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	41890: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.8.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	76185: {
		fallback: () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(30883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.3.0 || ^16.0.0-alpha || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	82948: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.3.0 || ^16.0.0-alpha || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	36273: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">= 16.14",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	15457: {
		fallback: () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(92451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"386": [
		76185,
		82948
	],
	"793": [
		36119,
		43848,
		93788
	],
	"873": [
		30873
	],
	"1890": [
		41890
	],
	"2741": [
		43591,
		24185,
		20287,
		82904,
		70291,
		79790,
		10473,
		67273,
		80582,
		17986,
		4266,
		28975,
		23398,
		67465,
		32196,
		83100,
		71962,
		37794
	],
	"6273": [
		36273
	],
	"8458": [
		98458
	],
	"9707": [
		15457
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}